<template>
  <div>
      <router-view />
	  <div style="clear: both;float: left;width: 100%;">&nbsp;</div>
  </div>
</template>

<script>

export default {
  components: { }
};
</script>
